import { useEffect } from 'react';

export function useBlockNegativeInput() {
	useEffect(() => {
		const handleKeyDown = (e: KeyboardEvent) => {
			const target = e.target as HTMLInputElement;
			if (target.tagName === 'INPUT' && target.type === 'number' && ['-', '+', 'e', 'E'].includes(e.key)) {
				e.preventDefault();
			}
		};
		document.addEventListener('keydown', handleKeyDown);
		return () => document.removeEventListener('keydown', handleKeyDown);
	}, []);
}
